module["exports"] = [
  "#{street_suffix} #{Name.first_name}",
  "#{street_suffix} #{Name.first_name} #{Name.last_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es/address/street_name.js
 ** module id = 590
 ** module chunks = 0
 **/